module.exports = __webpack_public_path__ + "static/media/3.e618ff1d.jpg";